require('./bootstrap')

import CustomSelect from './components/customSelect.vue'; // Import your component

Vue.component('dateRanges', require('./components/dateranges.vue').default)
Vue.component('customSelect', CustomSelect)

alertify.defaults.notifier.delay = 30;
alertify.defaults.notifier.closeButton = true;
alertify.set('notifier','position', 'top-right');
alertify.alert().setting({'closable' : false});
alertify.confirm().set('reverseButtons', true);
